export default __webpack_public_path__ + "static/media/tortuous.79982162.jpg";